import { createStore } from 'vuex'
import permissions from '@/store/modules/permissions.js'

export const store = createStore({
	modules:{
		permissions
	},
	strict: process.env.NODE_ENV !== 'production'
})